import $ from 'jquery';
import map from './index';
import mapconfig from './config';
import urlparams from '../../utility/urlparams';
import geocoder from './geocoder';

const $storeWidget = $('[data-module="storelist"]');
const storesList = $('[data-store]');
const storesListCache = storesList;
const $filterForm = $('form.store-list-search');
const $filterFormInput = $filterForm.find('[name="q"]');
const resultsContainer = $('.store-list-results');
let regionsSearchClone;
let storesSearchClone;
const storeListScrollable = $('.store-list');
const storeListMain = $('.store-list-ul');
const regions = $('[data-region]');
const $backbutton = $('.list-back-button');

// custom filters
const filterKeys = $('[data-filterkeys]');
const filterKeysArray = [];

// search
let queryClean = '';
let queryCache;
let manualSubmitted = false;
const queryIsNumbersOnly = false;
let advancedSearchTimer;
let postalCodeLength;

// search result states class and dom
const _noResultText = '.no-results-content__text';
const _noResultTextAdvancedMultiple = '.no-results-content__textAdvaced--multiple';
const _noResultTextAdvancedZero = '.no-results-content__textAdvaced--zero';
const _noResultSpinner = '.no-results-content__spinner';
const _noResultAdvancedSearchButton = '.button-advanced-search';

const $noResultText = $(_noResultText);
const $noResultTextAdvanced = $(_noResultTextAdvancedMultiple + ', ' + _noResultTextAdvancedZero);
const $noResultSpinner = $(_noResultSpinner);
const $noResultAdvancedSearchButton = $(_noResultAdvancedSearchButton);


// animation dom
let hasSelectedStore = false;
const widgetWrap = $('.store-widget-wrap');
const widgetWrapInner = $('.store-widget-wrap-inner');
const widgetWrapDefaultHeight = widgetWrapInner.height();
const selectedStoreWrap = $('.selected-store-wrap');
const storeListWrap = $('.store-list-wrap');
const selectedStoreContent = $(selectedStoreWrap.find('.hero-store-content'));
const selectedStoreTail = $(selectedStoreWrap.find('.hero-store-tail'));
// widgetWrapInner.height(widgetWrapDefaultHeight);

const $storeTypeLinks = $('.js-storetype-link');
const currentStoreCategori = false;

const ADVANCESEARCH_DEV = true; // to implement the feature locally but keep seperate from prod build.
let ADVANCESEARCH_BUTTON;

function init() {

    if ($storeWidget.length < 1) return;

    postalCodeLength = mapconfig.postalLength;
    setUpSearchClone();

    // Store list widget
    addRegionToggle();
    addStoreListEvents();
    addFormFilterHandlers();

    const query = urlparams.getParameterByName('q');
    if (query) {
        $filterFormInput.val(query);
        searchSubnmitHandler();
    }

    hackForNoRegions();// temp lang fix

    /*
        var hostString = ""+window.location.hostname+"";
        if( hostString.indexOf('local') != -1  || hostString.indexOf('192.168') != -1){
        ADVANCESEARCH_DEV = true;
        }
    */

    if (ADVANCESEARCH_DEV) {
        ADVANCESEARCH_BUTTON = $('.button-advanced-search');
        ADVANCESEARCH_BUTTON.on('click', function () {
            doAdvancedSearch(queryClean);
        });
    }

    $('[data-store] a').on('mouseenter', function (e) {
        const storeMarkerID = $(this).parent().data('store');
        map.setMarkerByStoreId(storeMarkerID);
    });

    //
    if (filterKeys.length > 0){
        addFilterKeys();
    }

}

function addFilterKeys(){
    const keys = filterKeys.find('input[type="checkbox"]');
    keys.each(function(i, el){

        $(el).on('change', function(e){
            if (el.checked){
                filterKeysArray.push(el.value);
            } else {
                filterKeysArray.pop(el.value);
            }
            updateStoreListByFilters();
        });
    });

}
function updateStoreListByFilters(){
    storesList.add(storesSearchClone).each(function(i){
        const filters = $(this).data('filters').split(' ');
        let valid = false;
        for (let j = 0; j <= filters.length; j++ ){
            if (filterKeysArray.indexOf(filters[j]) != -1) {
                valid = true;
            }
        }
        if (filterKeysArray.length < 1 || valid){
            $(this).removeClass('no-match');
        } else {
            $(this).addClass('no-match');
        }
    });

    regions.add(regionsSearchClone).each(function(i){
        const stores = $(this).find('[data-store]');
        if (listLengthWhenFiltered(stores) === 0){
            $(this).addClass('no-match');
        } else {
            $(this).removeClass('no-match');
        }
    });

    if ($('.active-region.no-match').length > 0){
        clearActiveRegion();
    }

    if (queryClean != ''){
        filterByString(queryClean);
    }
    map.updateMarkersByFilters(filterKeysArray);
}
function listLengthWhenFiltered(listOfNodes){
    let count =  0;
    $(listOfNodes).each(function(i){
        const filters = $(this).data('filters').split(' ');
        let valid = false;
        for (let j = 0; j <= filters.length; j++ ){
            if (filterKeysArray.indexOf(filters[j]) != -1) {
                valid = true;
            }
        }
        if (filterKeysArray.length < 1 || valid){
            count++;
        }
    });
    return count;
}

function setUpSearchClone() {
    regionsSearchClone = $('<div data-region="result"></div>');
    storesSearchClone = storesList.clone();
    regionsSearchClone.append(storesSearchClone);
    resultsContainer.html(regionsSearchClone);
}


// temp lang fix
function hackForNoRegions() {
    regions.each(function hackForNoRegionsLog(i, el) {
        const region = $(el).data('region');
        if (!region) {

            $storeWidget.addClass('tempfix-lang'); // add style for backbutton to quickfix
            $(el).trigger('click'); // show empty region as default

            $backbutton.off('click'); // remvoe default clearing of region
            $backbutton.on('click', function (e) { // add new clearing of region that default to the no-name-region
                e.preventDefault();
                clearActiveRegion();
                clearSearchField();
                $(el).trigger('click');
            });
        }
    });
}

function selectStore(id) {
    const currentStoreState = hasSelectedStore;
    const storeClone = regionsSearchClone.find('[data-store="' + id + '"]');
    const lng = parseFloat(storeClone.data('lng'));
    const lat = parseFloat(storeClone.data('lat'));
    map.setMapView(lng, lat);
    $storeWidget.addClass('has-selected-store');
    hasSelectedStore = true;

    map.setMarkerByStoreId(id);
    if (!currentStoreState) {
        updateSelectedStoreContent(id);
        animateWrapHeight();
    } else {
        updateSelectedStoreContent(id);
        animateWrapHeight(0, 0);
    }

    $('html, body').animate({scrollTop: '0'});
    // selectedStoreContent.html( $('[data-store-info="'+id+'"]').html() );
}

function addRegionToggle() {
    regions.on('click', function () {
        const $el = $(this);
        if ($el.hasClass('active-region')){
            return;
        }
        $el.toggleClass('active-region').siblings().removeClass('active-region');
        checkActiveRegion();
    });

    $backbutton.on('click', function (e) {
        e.preventDefault();
        clearActiveRegion();
        clearSearchField();
    });
}

function checkActiveRegion() {
    const actives = $storeWidget.find('.active-region');
    if (actives.length > 0) {
        $storeWidget.addClass('has-active-region');
    } else {
        $storeWidget.removeClass('has-active-region');
    }
    storeListScrollTop();
}

function clearActiveRegion() {
    regions.removeClass('active-region');
    $storeWidget.removeClass('isSearching');
    $storeWidget.removeClass('has-selected-store');
    hasSelectedStore = false;
    checkActiveRegion();
    animateWrapHeight(400);
}

function addStoreListEvents() {
    storesList.add(storesSearchClone).on('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        selectStore($(this).data('store'));
    });
}

function updateResultList() {
    resultsContainer.html();
}

function storeListScrollTop() {
    storeListMain.scrollTop(0);
}

function animateWrapHeight(delayArg, animDurationArg) {
    const delay = delayArg || 0;
    const animDuration = (animDurationArg != undefined) ? animDurationArg : 300;
    const targetHeight = (hasSelectedStore) ? selectedStoreWrap.height() : widgetWrapDefaultHeight;

    widgetWrapInner.delay(delay).animate({
        'height': targetHeight
    }, animDuration, function () {
        if (hasSelectedStore) {
            storeListWrap.css('position', 'absolute');
            selectedStoreWrap.css('position', 'relative');
        } else {
            storeListWrap.css('position', 'relative');
            selectedStoreWrap.css('position', 'absolute');
        }
        widgetWrapInner.css('height', 'auto');
    });
}

// form search
function addFormFilterHandlers() {
    $filterForm.on('submit', function (e) {
        e.preventDefault();
        manualSubmitted = true;
        searchSubnmitHandler();
    });
    $filterFormInput.on('keyup', debounce(searchSubnmitHandler, 300));
}

function searchSubnmitHandler() {
    const val = $filterFormInput.val();
    if (queryCache === val && !manualSubmitted) {
        return false;
    }
    queryCache = val;
    hideSearchMessagesExcept(_noResultText + ',' + _noResultAdvancedSearchButton);

    if (val && val !== '' && val.length >= postalCodeLength || manualSubmitted && val !== '') {
        // && val != inputValueCache  ----
        // inputValueCache = val;
        filterByString(val);
        $storeWidget.addClass('isSearching');
    } else {
        $storeWidget.removeClass('has-no-results');
        $storeWidget.removeClass('isSearching');
    }
    storeListScrollable.scrollTop(0);

}

function clearSearchField() {
    $filterFormInput.val('');
    searchSubnmitHandler();
    map.setDefaultView();
}

function filterByString(string) {
    $storeWidget.removeClass('has-no-results');

    queryClean = string.toLowerCase(); // .replace(/-/g, "").replace(/ /g, "");
    let totalCount = 0;
    const listOfDomResult = [];

    regionsSearchClone.each(function() {
        const $region = $(this);
        let count = 0;

        $region.find('[data-store]').each(function() {
            const $store = $(this);
            const searchString = $store.data('search-string').toLowerCase();

            if (searchString.indexOf(queryClean) !== -1) {
                // Show
                $store.show();
                count++;
                totalCount++;
                listOfDomResult.push($store);
            } else {
                // hide
                $store.hide();
            }
        });

        if (count === 0) {
            $region.hide();
        } else {
            $region.show();
        }
    });

    // check for postalcodes
    const reg = /^\d+$/;
    if (reg.test(queryClean) && queryClean.length >= postalCodeLength ) {
        // if postal do advanced to get postal hit coords for zoom map
        if (totalCount === 1 || listLengthWhenFiltered(listOfDomResult) === 1){
            const singleItem = $(listOfDomResult[0]);
            filterByLocation(singleItem.data('lat'), singleItem.data('lng'));
        } else {
            doAdvancedSearch(queryClean);
            $storeWidget.addClass('has-no-results');
        }

    } else if (totalCount === 0 || listLengthWhenFiltered(listOfDomResult) === 0) {
        // simple search only
        $storeWidget.addClass('has-no-results');
        // advanced search
        if (manualSubmitted) {
            doAdvancedSearch(queryClean);
            manualSubmitted = false;
        }

    }
    if (manualSubmitted && !reg.test(queryClean) || !queryClean.length >= postalCodeLength) {
        doAdvancedSearch(queryClean);
        manualSubmitted = false;
    }
    updateResultList();
}

function hideSearchMessagesExcept(toShow) {
    $noResultText.hide();
    $noResultTextAdvanced.hide();
    $noResultSpinner.hide();
    $noResultAdvancedSearchButton.hide();
    if (toShow) {
        $(toShow).show();
    }
}

function goToAdvancedResultHit(resultObj) {

    const lat = resultObj.geometry.location.lat();
    const lng = resultObj.geometry.location.lng();
    filterByLocation(lat, lng);
}

function filterByLocation(lat, lng) {
    const closestStores = map.findStoresNearest({lat: lat, lng: lng});
    const storeDOMs = [];
    const bounds = new google.maps.LatLngBounds();
    closestStores.forEach(function (storeMarkerObj) {
        storesSearchClone.each(function (i, el) {
            if ($(el).data('store') == storeMarkerObj.storeMarker.storeId ) {
                storeDOMs.push($(el));
                bounds.extend(new google.maps.LatLng(storeMarkerObj.storeMarker.position.lat(), storeMarkerObj.storeMarker.position.lng() ) );
            }
        });
    });
    if (listLengthWhenFiltered(storeDOMs) === 0){
        hideSearchMessagesExcept(_noResultTextAdvancedZero);
    } else {
        hideSearchMessagesExcept(false);
        $(storeDOMs).each(function (i, storeDOM) {
            $(storeDOM).add($(storeDOM).parents('[data-region]')).show();
            $(storeDOM).parent().append($(storeDOM));
            $(storeDOM).show();
        });
        map.gotoBounds(bounds);
        $storeWidget.removeClass('has-no-results');
        updateResultList();
    }
}

function doAdvancedSearch(queryClean, callback) {
    $storeWidget.addClass('advancedSearch');
    hideSearchMessagesExcept('.preloader');
    geocoder.callGoogleApi(queryClean, function (success, data) {
        $storeWidget.removeClass('advancedSearch');

        if (success) {
            $storeWidget.addClass('advancedSearch--succes');

            if (data.result.length == 1) {
                const match = data.result[0];
                if (match.address_components.length > 1) {
                    hideSearchMessagesExcept(false);
                    goToAdvancedResultHit(match);

                } else {
                    map.setDefaultView();
                    hideSearchMessagesExcept(_noResultTextAdvancedZero);
                }
            } else {
                hideSearchMessagesExcept(_noResultTextAdvancedMultiple);
            }
        } else {

            hideSearchMessagesExcept(_noResultTextAdvancedZero);
        }
        if (typeof(callback) === 'function') {
            callback(success);
        }
    });
}

function updateSelectedStoreContent(id) {
    const store = $('[data-store-info="{' + id + '}"]');

    const storeContentHtml = store.find('.hero-store-content').html();
    const storeTailHtml = store.find('.hero-store-tail').html();

    // TODO: animate height in this case
    selectedStoreContent.html(storeContentHtml); // $( store.find('.hero-store-content').html())
    selectedStoreTail.html(storeTailHtml);
}

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this, args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export default {
    init,
    selectStore
};
